import { ELabelColor, ILabel } from '../../../types/label';
import { IOffer } from 'fragments/OfferCardWidget/shared/types/offer';
import { IOfferReduxApi } from 'fragments/OfferCardWidget/shared/types/offer-card';
import { IJsonQuery } from 'shared/json_query';
import { isNewobjectPage } from 'shared/utils/isNewobjectPage';

interface IParams {
  labelsV1: ILabel[];
  labelsV2: ILabel[];
  extensionLabels: ILabel[];
  api: IOfferReduxApi;
  offer: IOffer;
  position: number;
  jsonQuery: IJsonQuery;
}

export function getNewbuildingKpnLabels({
  labelsV1,
  labelsV2,
  extensionLabels,
  offer,
  api,
  position,
  jsonQuery,
}: IParams) {
  const kpnLabels: ILabel[] = [];

  const isUnique = offer.isUnique;
  const isNewbuildingBrokerBookingEnabled = offer.newbuildingBroker?.bookingEnabled;

  if (isUnique) {
    kpnLabels.push({ color: ELabelColor.Blue, text: 'Только на Циан' });
  }

  // Лейблы с бэка, пока там только выключенная Льготная ипотека.
  kpnLabels.push(...labelsV2);
  // Лейблы с бэка: https://ci-gitea.cian.tech/cianmedia/search-offers/src/commit/9afc7e76dc0bf14378e19bd84847d54bb36bde32/src/search_offers/services/search_offers_for_desktop/main.py#L413-L413
  kpnLabels.push(...labelsV1);
  // Лейблы добивок вида "Дороже на xxx руб".
  kpnLabels.push(...extensionLabels);

  if (isNewbuildingBrokerBookingEnabled) {
    if (isNewobjectPage(jsonQuery)) {
      kpnLabels.push({
        color: ELabelColor.SimpleBlue,
        text: 'Онлайн-бронирование',
      });
    } else {
      kpnLabels.push({
        color: ELabelColor.SimpleBlueIconed,
        text: 'Онлайн-бронирование',
        onClick: () => api.openNewbuildingBrokerCallbackPopup(offer, position),
      });
    }
  }

  return kpnLabels;
}
